import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './HundredDaysProgram.css';

const HundredDaysProgram = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['१०० दिवस कार्यक्रम', 'शंभर दिवस', 'विशेष कार्यक्रम'],
    en: ['100 days program', 'hundred days', 'special program']
  });

  const pageHeaderData = {
    title: {
      marathi: '१०० दिवसांचा कार्यक्रम',
      english: '100 Days Program'
    },
    subtitle: {
      marathi: 'मंडळाचा १०० दिवसांचा कार्यक्रम',
      english: 'Board\'s 100 Days Program'
    }
  };

  return (
    <div className="hundred-days-program">
      <div className="hundred-days-program-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="program-content" data-read-section="hundred-days-program-content">
          <section className="program-section">
            <h2 className="section-title">
              {isMarathi() ? 'कार्यक्रमाची माहिती' : 'Program Information'}
            </h2>
            <div className="section-content">
              <div className="section-text">
                {isMarathi() ? (
                  <div>
                    <p>महाराष्ट्र कामगार कल्याण निधी मंडळाचा १०० दिवसांचा कार्यक्रम हा कामगारांच्या कल्याणासाठी राबविण्यात येणारा एक महत्वाचा उपक्रम आहे.</p>
                    <p>या कार्यक्रमाची तपशीलवार माहिती लवकरच अपडेट केली जाईल.</p>
                  </div>
                ) : (
                  <div>
                    <p>The 100 Days Program of Maharashtra Labour Welfare Fund Board is an important initiative for the welfare of workers.</p>
                    <p>Detailed information about this program will be updated soon.</p>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HundredDaysProgram;

